/**
 * 言語の種類で該当するオブジェクトを返す
 * @param locale string 言語
 * @param data Oject 言語データ
 * @returns data['ja']
 */
export default function getInfoByLocale(locale: string, data: Object) {
  if (data[locale]) return data[locale]
  return data['ja']
}
